import { shortCurrencyFormatter } from 'components/KPIs/helpers';
import { currencyFormatter } from 'components/KPIs/helpers';
import React from 'react';
import ReactApexChart from 'react-apexcharts';

/**
 * A donut chart that displays member profit segments for each team.
 * Each slice represents a member's profit.
 *
 * @param {Array} teams - Array of team objects, each with:
 *    - name: string
 *    - gross_profit: number
 *    - members: array of member objects, each with:
 *          - name: string
 *          - income: number
 *          - expense: number
 * @param {Function} valueExtractor - Optional function to extract member data.
 *    It should return an object containing:
 *      - memberSeries: Array<number>
 *      - memberLabels: Array<string>
 *      - memberColors: Array<string>
 */
const MemberDonutChart = ({
    teams,
    valueExtractor,
    defaultOutterFormatter = shortCurrencyFormatter,
    label = 'Empty Label',
}) => {
    // Extract member data
    const {
        memberSeries,
        memberLabels,
        memberColors,
    } = valueExtractor(teams);

    // Options for the donut chart (members) with labels
    const options = {
        chart: {
            type: 'donut',
            animations: { enabled: false },
            toolbar: {
                show: true,
                tools: {
                    download: true,
                },
            },
            events: {
                dataPointSelection: (event, chartContext, config) => {
                    const selectedMember = memberLabels[config.dataPointIndex];
                    console.log('Selected Member:', selectedMember);
                    // Trigger additional actions (e.g., open a modal or navigate)
                },
            },
        },
        labels: memberLabels,
        colors: memberColors,
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '14px',
                            fontWeight: 800,
                            offsetY: -20,
                            formatter: (val) => val,
                        },
                        value: {
                            show: true,
                            fontSize: '26px',
                            fontWeight: 500,
                            offsetY: 0,
                            formatter: (val) => defaultOutterFormatter(val),
                        },
                        total: {
                            show: true,
                            label: label,
                            fontSize: '14px',
                            fontWeight: 600,
                            formatter: (w) => {
                                const sum = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                return defaultOutterFormatter(sum);
                            },
                        },
                    },
                },
            },
        },
        // title: {
        //     text: 'Team member',
        //     align: 'left',
        //     style: {
        //         fontSize: '16px',
        //         fontWeight: 300,
        //     },
        // },
        legend: {
            show: true,
            position: 'left',
            fontWeight: 600,
            clusterGroupedSeries: true,
        },
        tooltip: {
            y: { formatter: (val) => defaultOutterFormatter(val) },
        },
    };

    return (
        <div style={{ width: '100%', height: '500px' }}>
            <ReactApexChart
                options={options}
                series={memberSeries}
                height={'480px'}
                type="donut"
            />
        </div>
    );
};

export default MemberDonutChart;